import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productTemplateIdZodSchema } from "@@/shared/products/templates/product-template-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const duplicateProductTemplateCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("DUPLICATE_PRODUCT_TEMPLATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    templateId: productTemplateIdZodSchema,
    // TODO!
    // vet inte hur vi ska lösa detta på bästa sätt, antar att olika produkt template typer
    // kräver olika saker, så kanske vi behöver skapa scheman för kommandot varje produkt
    // template typ egentligen alternativet är olika kommandon men kräver samma sak egentligen
    // Kommer de att vara väldigt olika kanske det är lättare att ha olika kommandon helt och hållet
});

type DuplicateProductTemplateCommand = z.infer<
    typeof duplicateProductTemplateCommandZodObject
>;
const duplicateProductTemplateCommandZodSchema: z.ZodSchema<DuplicateProductTemplateCommand> =
    duplicateProductTemplateCommandZodObject;

type FactoryParams = Except<
    DuplicateProductTemplateCommand,
    "_id" | "_type" | "_createdAt"
>;
const duplicateProductTemplateCommandFactory = (params: FactoryParams) => {
    const DuplicateProductTemplateCommand: DuplicateProductTemplateCommand = {
        ...params,
        _id: generateId({ prefix: "command__" }),
        _type: "DUPLICATE_PRODUCT_TEMPLATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return DuplicateProductTemplateCommand;
};

export {
    duplicateProductTemplateCommandFactory,
    duplicateProductTemplateCommandZodObject,
    duplicateProductTemplateCommandZodSchema,
};
export type { DuplicateProductTemplateCommand };
